module.exports = __webpack_public_path__ + "img/zero-suit-samus-min.49e5182b.png";